import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
  FormControl,
} from "@mui/material";
import { X } from "@phosphor-icons/react";
import { BackButton } from "../../pages/MatterDetails/MatterDetailsStyled";
import MultilineTextField from "../TextField/MultilineTextField";
import RecipientDropdown from "../Drowdown";

const ReviewActionModal = ({
  open,
  onClose,
  btnTxtSecondary,
  onPrimaryClick,
  onSecondaryClick,
  disabled,
  config,
  comment,
  setComment,
  recipientOptions = [],
  selectedRecipients = [],
  setSelectedRecipients = () => {},
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      slotProps={{
        paper: {
          sx: {
            width: "65%",
            borderRadius: "12px",
          },
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          paddingBottom: 0,
        }}
      >
        <Typography
          align="center"
          sx={{
            fontWeight: 600,
            fontSize: "20px",
            fontFamily: "manrope",
          }}
          gutterBottom
        >
          {config?.heading}
        </Typography>

        <BackButton>
          <X
            size={20}
            onClick={onClose}
            data-testid={"review-action-close-btn"}
          />
        </BackButton>
      </DialogTitle>

      <DialogContent>
        <Typography
          variant="body2"
          sx={{
            fontFamily: "manrope",
            fontSize: "12px",
            fontWeight: 500,
            color: "#48566B",
            mb: 2,
          }}
        >
          {config?.content}
        </Typography>

        {config?.requiresRecipient && (
          <Box sx={{ mb: 2 }}>
            <FormControl fullWidth>
              <RecipientDropdown
                selectedData={selectedRecipients}
                setSelectedData={(recipients) => {
                  setSelectedRecipients(recipients.slice(-1));
                }}
                allRecipients={recipientOptions}
                setShowHelper={() => {}}
              />
            </FormControl>
          </Box>
        )}

        <MultilineTextField
          value={comment}
          onChange={setComment}
          placeholder="Add comments (Optional)"
        />
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: "flex-end",
          p: 2,
          gap: "2px",
          borderTop: "1px solid #F3F4F7",
        }}
      >
        <Button
          variant="outlined"
          onClick={onSecondaryClick || onClose}
          sx={{
            fontFamily: "manrope",
            borderRadius: "6px",
            border: "1px solid #DDE2E9",
            padding: "10px 12px",
            height: "32px",
            textTransform: "none",
            fontWeight: 600,
            backgroundColor: "#F3F4F7",
            color: "#1B2028",
            fontSize: "13px",
          }}
        >
          {btnTxtSecondary}
        </Button>

        <Button
          variant="contained"
          disableElevation
          onClick={onPrimaryClick}
          disabled={disabled}
          sx={{
            fontFamily: "manrope",
            borderRadius: "6px",
            padding: "10px 12px",
            height: "32px",
            textTransform: "none",
            fontWeight: 600,
            backgroundColor: "#0D47A1",
            color: "#FFFFFF",
            fontSize: "13px",
          }}
        >
          {config?.btnTxtPrimary}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ReviewActionModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  btnTxtSecondary: PropTypes.string,
  onPrimaryClick: PropTypes.func.isRequired,
  onSecondaryClick: PropTypes.func,
  disabled: PropTypes.bool,
  config: PropTypes.shape({
    heading: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    btnTxtPrimary: PropTypes.string.isRequired,
    requiresRecipient: PropTypes.bool,
  }).isRequired,
  comment: PropTypes.string.isRequired,
  setComment: PropTypes.func.isRequired,
  recipientOptions: PropTypes.array,
  selectedRecipients: PropTypes.array,
  setSelectedRecipients: PropTypes.func,
};

export default ReviewActionModal;
